module.exports = __webpack_public_path__ + "static/media/a13.7393911b.jpg";